import React, { useMemo } from 'react';
import { SOURCE_URL } from '../../../../config';
import { setDetailInfoId, setPackInfoDetailStatus } from '../GetStartedSlice';
import { useAppDispatch, useAppSelector } from '../../../../stores/hook';
import translations from '../../../../text/get-started-translations.json';
import language from '../../../../utils/LanguageSettings';
import { IPriceOption } from '../../types';
import { Link, useLocation } from 'react-router-dom';
import { OTT, STB } from '../../constants';
import ImageFallback from '../../../../utils/ImageFallback';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import defaultImgBanner from '../../../../images/icon/default-img-banner.png'
import h1Box from "../../../../images/icon/h1box.png"

interface SwiperItemProps {
  imgSrc: string;
  title: string;
  campaignParameter?: string;
  description: string;
  includes: {
    data: Array<{
        attributes: {
            name: string;
        };
        id: number;
    }>;
  };
  locale?: string;
  price?: string;
  ott_12Mth_price?: number;
  stb_price?: number,
  stb_12Mth_price?: number;
  ottPriceDetail:string;
  stbPriceDetail:string;
  ottCampaign: string;
  stbCampaign?: string;
  stb_12M_campaign?: string;
  box_detail_id?: string;
  Tagline?: string;
  PriceOptions?: Array<IPriceOption>;
  type?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const SwiperItem: React.FC<SwiperItemProps> = (props) => {
  const {
    imgSrc,
    title,
    campaignParameter,
    description,
    includes,
    locale,
    ottPriceDetail,
    stbPriceDetail,
    ott_12Mth_price,
    stb_12Mth_price,
    price,
    stb_price,
    ottCampaign,
    stbCampaign,
    stb_12M_campaign,
    onClick,
    box_detail_id,
    Tagline,
    PriceOptions,
    type
  } = props;

  const location = useLocation();
  const isArticlePage = location.pathname.includes('/blog/');
  const langKey = (isArticlePage && locale) || language;
  const pageTranslations = translations[langKey as keyof typeof translations];

  const COMBO_PACK_PREFIX = '/combo-pack';
  const isTvBoxPage = useAppSelector((state) => state.getStarted.isTvBoxPage)
  const priceDetail =  (isTvBoxPage || type === 'stb')? stbPriceDetail : ottPriceDetail;
  //  const filteredPriceOptions = useMemo(() => {
  //   const tmpFilteredPriceOptions = [] as IPriceOption[]
  //   if (PriceOptions && PriceOptions.length > 0) {
  //     if (isTvBoxPage) {
  //       PriceOptions.forEach((priceOption) => {
  //         if (priceOption.Platform === STB) {
  //           tmpFilteredPriceOptions.push(priceOption)
  //         }
  //       })
  //     } else {
  //       PriceOptions.forEach((priceOption) => {
  //         if (priceOption.Platform === OTT) {
  //           tmpFilteredPriceOptions.push(priceOption)
  //         }
  //       })
  //     }
        
  //   }
  //     return tmpFilteredPriceOptions
  // }, [PriceOptions, isTvBoxPage])

  const buttonText = useMemo(
    () => {
      if (PriceOptions && PriceOptions.length > 1) {
        return pageTranslations.SeeOptions;
      } else {
        return pageTranslations.SubscribeNow;
      }
    }, [PriceOptions, pageTranslations])
// TODO add font-weight 500 
    const priceOption = useMemo(
    () => {
        if (PriceOptions && PriceOptions.length === 1) {
          let priceOption = {
            priceText: '',
            priceDetail: ''
          }
          switch(PriceOptions[0].Type) {
            case 'Yearly':
              priceOption.priceText = `${(isTvBoxPage || type === 'stb') ? '<b>' : '<span>' + pageTranslations.Avg +' </span><b>'}$${(PriceOptions[0].Price / 12).toLocaleString('zh-HK')}</b> / <span>${pageTranslations.Month}</span>`;
              priceOption.priceDetail = (isTvBoxPage || type === 'stb')
              ? pageTranslations['12MthsCommitment']
              : `${pageTranslations.BilledAs}$${PriceOptions[0].Price}${pageTranslations.Every12Mths}<br/>${pageTranslations.Instant}`; 
              break;
            case 'Monthly':
              priceOption.priceText = '<b>$' + PriceOptions[0].Price +'</b> / <span>' + pageTranslations.Month + '</span>';
              priceOption.priceDetail = (isTvBoxPage || type === 'stb')
              ? pageTranslations['12MthsCommitment']
              : pageTranslations.Instant;
              break;
            case 'Daily':
              priceOption.priceText = '<b>$' + PriceOptions[0].Price + '</b> / <span>' + pageTranslations.day + '</span>';
              priceOption.priceDetail = pageTranslations.Instant;
              break;
            case 'Event':
              priceOption.priceText = '<b>$' + PriceOptions[0].Price + '</b> / <span>' + pageTranslations.EventPass + '</span>';
              priceOption.priceDetail = pageTranslations.Instant;
              break;
          }

          return priceOption;
        } else if (PriceOptions && PriceOptions.length > 1) {
          const priceDetail = (isTvBoxPage || type === 'stb') ? pageTranslations['12MthsCommitment'] : pageTranslations.Instant;
          let priceOption = {
            priceText: "",
            priceDetail: priceDetail,
          };
          switch (PriceOptions[0].Type) {
            case "Yearly":
              priceOption.priceText = `<span>${pageTranslations.From}</span> <b>$${(PriceOptions[0].Price / 12).toLocaleString('zh-HK')}</b><span> / ${pageTranslations.MonthThen}</span>`;
              break;
            case "Monthly":
              priceOption.priceText = `<span>${pageTranslations.From}</span> <b>$${PriceOptions[0].Price}</b><span> / ${pageTranslations.MonthThen}</span>`;
              break;
            case "Daily":
              priceOption.priceText = `<b>$${PriceOptions[0].Price}</b><span> / ${pageTranslations.day}</span>`;
              priceOption.priceDetail = pageTranslations.Instant;
              break;
            case "Event":
              priceOption.priceText = `<b>$${PriceOptions[0].Price}</b><span> / ${pageTranslations.EventPass}</span>`;
              priceOption.priceDetail = pageTranslations.Instant;
              break;
          }
          return priceOption;
        }
      return {
            priceText: '',
            priceDetail: ''
          }
    }, [PriceOptions, pageTranslations])


  const dispatch = useAppDispatch();

  const handleClick = (id: string) => {
    dispatch(setDetailInfoId(id));
    dispatch(setPackInfoDetailStatus(true));
  }

  return (
    <div className="item" data-campaign={campaignParameter?.toLowerCase().replace(/\s+/g, '-')}>
      <div className="card">
        <ImageFallback
          primarySrc={imgSrc? `${SOURCE_URL}${imgSrc}` : ''}
          defaultSrc={defaultImgBanner}
        />
        <div className="content">
          <div className="top">
            {(isTvBoxPage || type === 'stb') && (
              <>
                <div className={`stb-heading`}>
                  <div className={`heading-plusbox`}>
                    <h4>{title}</h4>
                    <h5 className={`h1box`}>+ {pageTranslations.TopBox}</h5>
                  </div>
                  <img
                    src={h1Box}
                    alt="H1 Box"
                  ></img>
                </div>
                <div className="desc">
                  <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{description}</ReactMarkdown>
                </div>
              </>
            )}
            {!(isTvBoxPage || type === 'stb') && (
              <>
                <h4>{title}</h4>
                <div className="desc">
                  <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{description}</ReactMarkdown>
                </div>
              </>
            )}
          </div>

          <div className="includes">
            <h5>{pageTranslations.PlanIncludes}</h5>
            <ul>
              {(isTvBoxPage || type === 'stb') && <li><span className='h1box'>{pageTranslations.TopBox}</span></li>}
            {Array.isArray(includes?.data) && includes?.data?.length > 0 ? (
              includes?.data?.map((include, index) => (
                <li key={index}><a onClick={() => handleClick(include.id.toString())} className="show-pack" data-pack-name={include}>{include.attributes.name}</a></li>
              ))
             ) : ((!isTvBoxPage || type === 'ott') && <li>{pageTranslations.NoIncludes}</li> )}
            </ul>
          </div>

          <div className="bottom-cta col">
            <div className="price-wrap">
              {
                  <h3 className="price">
                    <div>
                      <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{priceOption.priceText}</ReactMarkdown>
                    </div>
                  </h3>
              }
                <small>
                  <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{Tagline || ""}</ReactMarkdown>
                </small>
            </div>
            
            <div className="btn-control">
              <button onClick={onClick} className={`btn primary subscribe-now`} ott-campaign={ottCampaign}>{buttonText}</button>
              {(isTvBoxPage || type === 'stb') && box_detail_id && <Link to={`${COMBO_PACK_PREFIX}/${box_detail_id}`} className="link arrow">{pageTranslations.LearnMore}</Link>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SwiperItem;